export const clientPortalMock = {
  client: {
    name: "Mariana Costa Ribeiro",
    role: "Cliente titular",
    profileType: "Pessoa fisica",
    email: "mariana.ribeiro@email.com",
    phone: "+55 (47) 99988-7766",
    city: "Joinville, SC",
    since: "Cliente desde fevereiro de 2026",
    accountStatus: "Acesso ativo",
  },
  caseSummary: {
    title: "Inventario extrajudicial e organizacao patrimonial familiar",
    protocol: "ACL-2026-041",
    area: "Familia e sucessoes",
    status: "Em andamento",
    priority: "Alta prioridade",
    owner: "Dra. Ana Carolina Lucena",
    updatedAt: "Atualizado em 28 de marco de 2026",
    summary:
      "O atendimento envolve a conducao do inventario, validacao documental, alinhamento entre herdeiros e estrategia de organizacao patrimonial para as proximas etapas.",
  },
  highlights: [
    {
      label: "Proxima reuniao",
      value: "02 abr 2026",
      detail: "Reuniao online as 14:30 com pauta documental e definicao de minuta.",
    },
    {
      label: "Documentos enviados",
      value: "9 de 12",
      detail: "Faltam 3 documentos para concluir a pasta inicial do atendimento.",
    },
    {
      label: "Pendencias ativas",
      value: "3",
      detail: "Assinatura da procuracao, certidao atualizada e comprovante bancario.",
    },
    {
      label: "Financeiro",
      value: "1 parcela pendente",
      detail: "Vencimento em 05 abr 2026 com lembrete automatico programado.",
    },
  ],
  nextSteps: [
    {
      title: "Enviar certidao de obito atualizada",
      status: "pendente",
      dueDate: "31 mar 2026",
      description:
        "Documento necessario para fechamento da pasta e conferencia final do inventario.",
    },
    {
      title: "Assinar procuracao digital",
      status: "urgente",
      dueDate: "01 abr 2026",
      description:
        "Assinatura eletronica liberada no portal para validar a representacao.",
    },
    {
      title: "Confirmar dados bancarios para partilha",
      status: "em analise",
      dueDate: "03 abr 2026",
      description:
        "Etapa preparatoria para consolidar a proposta final e evitar retrabalho posterior.",
    },
  ],
  timeline: [
    {
      date: "28 mar 2026",
      title: "Atualizacao estrategica registrada",
      text:
        "O escritorio concluiu a revisao da documentacao recebida e confirmou os proximos documentos necessarios para avancar com seguranca.",
      type: "update",
    },
    {
      date: "24 mar 2026",
      title: "Minuta inicial organizada",
      text:
        "Estrutura preliminar do inventario montada com base nos documentos ja recebidos e observacoes feitas pela cliente.",
      type: "document",
    },
    {
      date: "18 mar 2026",
      title: "Reuniao de alinhamento realizada",
      text:
        "Foram definidos prioridade, escopo inicial, riscos e estrategia de conducao mais adequada para o caso.",
      type: "meeting",
    },
    {
      date: "12 mar 2026",
      title: "Cadastro aprovado e onboarding iniciado",
      text:
        "A cliente recebeu acesso ao portal, checklist inicial e orientacoes de envio documental.",
      type: "onboarding",
    },
  ],
  documents: [
    {
      name: "Checklist inicial do atendimento.pdf",
      category: "Onboarding",
      status: "Disponivel",
      updatedAt: "28 mar 2026",
    },
    {
      name: "Minuta de inventario - versao 01.docx",
      category: "Peca em elaboracao",
      status: "Em revisao",
      updatedAt: "24 mar 2026",
    },
    {
      name: "Procuracao digital.pdf",
      category: "Assinatura",
      status: "Aguardando assinatura",
      updatedAt: "28 mar 2026",
    },
    {
      name: "Comprovante de honorarios - parcela 1.pdf",
      category: "Financeiro",
      status: "Disponivel",
      updatedAt: "20 mar 2026",
    },
  ],
  appointments: [
    {
      date: "02 abr 2026",
      time: "14:30",
      type: "Reuniao online",
      with: "Dra. Ana Carolina Lucena",
      note: "Revisao de documentos e definicao de proxima fase.",
    },
    {
      date: "09 abr 2026",
      time: "10:00",
      type: "Atendimento presencial",
      with: "Equipe do escritorio",
      note: "Assinatura final e conferencia de documentos fisicos, se necessario.",
    },
  ],
  messages: [
    {
      author: "Escritorio",
      time: "Hoje, 09:14",
      subject: "Resumo da ultima atualizacao",
      body:
        "Conferimos a documentacao recebida e liberamos no portal a procuracao para assinatura digital. Assim que essa etapa for concluida, conseguimos avancar com mais rapidez.",
    },
    {
      author: "Cliente",
      time: "Ontem, 18:42",
      subject: "Envio de documentos complementares",
      body:
        "Os comprovantes bancarios foram reunidos e serao enviados ainda hoje. Gostaria de confirmar se ha mais algum documento pendente alem da certidao.",
    },
  ],
  financial: {
    plan: "Honorarios em 3 parcelas",
    total: "R$ 7.500,00",
    paid: "R$ 5.000,00",
    pending: "R$ 2.500,00",
    nextCharge: "05 abr 2026",
    invoices: [
      {
        label: "Parcela 1",
        status: "Paga",
        amount: "R$ 2.500,00",
      },
      {
        label: "Parcela 2",
        status: "Paga",
        amount: "R$ 2.500,00",
      },
      {
        label: "Parcela 3",
        status: "Pendente",
        amount: "R$ 2.500,00",
      },
    ],
  },
};
